export { IntercomEnvironment, Recipients as IntercomRecipients } from './lib/types';
export { IntercomService } from './lib/intercom.service';
